"use client";

import Link from "next/link";

const Navbar = () => {
  const handleToggleNav = () => {
    const navCollapse = document.querySelector(".navbar .navbar-collapse");
    if (navCollapse?.classList.contains("show")) {
      navCollapse.classList.remove("show");
    } else {
      navCollapse?.classList.add("show");
    }
  };

  const handleNavLinkClick = () => {
    const navCollapse = document.querySelector(".navbar .navbar-collapse");
    if (navCollapse?.classList.contains("show")) {
      navCollapse.classList.remove("show");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bord blur">
      <div className="container o-hidden">
        <Link
          className="logo icon-img-100"
          href="/"
          onClick={handleNavLinkClick}
        >
          <img src="/assets/imgs/logo-light.png" alt="logo" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleToggleNav}
        >
          <span className="icon-bar">
            <i className="fas fa-bars"></i>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" href="/" onClick={handleNavLinkClick}>
                <span className="rolling-text">Home</span>
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                className="nav-link"
                href="/contact"
                onClick={handleNavLinkClick}
              >
                <span className="rolling-text">Contact Us</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="contact-button">
          <Link
            href="/contact"
            className="butn butn-sm butn-bg main-colorbg radius-5"
            onClick={handleNavLinkClick}
          >
            <span className="text">Let&apos;s contact</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
